/* globals FB */
export default class FacebookService {
  static SCRIPT_ID = "facebook-jssdk";
  static STATUS_CONNECTED = "connected";
  static STATUS_DECLINED = "declined";
  static LANGUAGES = {
    EN: "en_US", // English
    ES: "es_LA", // Spanish
    FR: "fr_FR", // French
    SV: "sv_SE", // Swedish
    NL: "nl_NL", // Dutch
    IT: "it_IT", // Italian
    PT: "pt_PT" // Portuguese
  };

  static digestUserInfo(response) {
    /* eslint-disable camelcase */
    const {
      location = null,
      id = null,
      first_name = null,
      last_name = null,
      gender = null,
      email = null,
      city = null,
      state = null
    } = response;

    const user = { id, first_name, last_name, gender, email, city, state };

    if (location && location.name) {
      const locationParts = location.name.split(",");

      if (locationParts[0]) {
        user.city = locationParts[0].trim();
      }

      if (locationParts[1]) {
        user.state = locationParts[1].trim();
      }
    }

    return user;
  }

  static initializeFacebook(appId, version) {
    window.fbAsyncInit = () => {
      FB.init({
        appId,
        version,
        xfbml: false, // parse XFBML
        status: true, // check login status
        cookie: true // enable cookies to allow the server to access the session
      });
    };
  }

  static loadFacebookJs(language) {
    if (document.getElementById(this.SCRIPT_ID)) {
      return;
    }

    let localization = this.LANGUAGES.EN;
    const js = document.createElement("script");
    const firstScript = document.getElementsByTagName("script")[0];

    if (this.LANGUAGES[language]) {
      localization = this.LANGUAGES[language];
    }

    js.id = this.SCRIPT_ID;
    js.src = `//connect.facebook.net/${localization}/sdk.js`;

    if (firstScript) {
      firstScript.parentNode.insertBefore(js, firstScript);
    } else {
      // if document doesn't have other scripts (tests), append to body
      document.body.append(js);
    }
  }

  static getDeclinedPermissions(userId) {
    return new Promise((resolve, reject) => {
      FB.api(
        `/${userId}/permissions`,
        "get",
        { status: this.STATUS_DECLINED },
        response => {
          if (response.error) {
            reject(response);
          } else {
            resolve(response);
          }
        }
      );
    });
  }

  static getLoginState(forceRefresh = false) {
    return new Promise(resolve => {
      FB.getLoginStatus(response => resolve(response), forceRefresh);
    });
  }

  static getUserInfo() {
    return new Promise((resolve, reject) => {
      FB.api(
        "/me",
        {
          fields: "id,gender,email,first_name,last_name,location"
        },
        response => {
          if (response.error) {
            reject(response);
          } else {
            resolve(this.digestUserInfo(response));
          }
        }
      );
    });
  }

  static promptForLogin() {
    return new Promise((resolve, reject) => {
      FB.login(
        response => {
          if (
            response.authResponse &&
            response.status === this.STATUS_CONNECTED
          ) {
            resolve(response);
          } else {
            reject(response);
          }
        },
        {
          return_scopes: true,
          auth_type: "rerequest",
          scope: "public_profile,email,user_location"
        }
      );
    });
  }
}
